import { Link } from 'react-router-dom';

export function ForbiddenPage(): JSX.Element {
  return (
    <div className="mx-auto max-w-lg py-16 text-center">
      <p className="text-sm font-medium text-danger">Acceso denegado</p>
      <h1 className="mt-2 text-2xl font-semibold tracking-tight text-slate-900">
        No tienes permisos para esta sección
      </h1>
      <p className="mt-3 text-sm text-slate-600">
        Tu plan o tu rol actual no incluye el scope necesario. Contacta con un administrador del tenant
        si crees que debería estar disponible.
      </p>
      <Link to="/dashboard" className="btn-primary mt-6 inline-flex">
        Volver al dashboard
      </Link>
    </div>
  );
}
